import {NolimitAudioPlayer} from "@nolimit/slot-audio/bin/NolimitAudioPlayer";
import {SlotGame} from "@nolimit/slot-game/bin/SlotGame";
import {NolimitConfig} from "@nolimit/slot-launcher/bin/settings/NolimitConfig";
import {NolimitHowl} from "@nolimit/slot-audio/bin/NolimitHowl";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2SoundConfig} from "../configs/FITH2SoundConfig";
import {TweenLite} from "gsap";
import {ArrayHelper} from "@nolimit/slot-game/bin/utils/ArrayHelper";
import {APISetting} from "@nolimit/slot-launcher/bin/interfaces/APISettingsSystem";
import {FITH2Helper} from "../utils/FITH2Helper";
import {MathHelper} from "@nolimit/slot-game/bin/utils/MathHelper";

export class FITH2SoundManager {
    private static _init: boolean;
    private static _newAvalanche: boolean;
    private static _xsLandingSoundPlayed: boolean;
    private static _scatterFlashSoundPlayed: boolean;
    private static _bigWinEndSoundPlayed: boolean[] = ArrayHelper.initArrayWithValues(5, () => false);
    private static _reelLandingSoundId: number[] = [];
    private static _currentBigWinLevel: number = -1;
    private static currentLoop: string;
    public static countUpEndSoundPlayed: boolean;
    private static _reelLandingSounds: string[] = [];

    private static _wildCounter: number;
    private static _xsCounter: number;
    private static _scatterLandingPlayed: boolean;
    private static _scatterLandExtraPlayed: boolean;
    private static _wildLandingPlayed: boolean;
    private static _wildLandingSounds: string[] = [];
    private static _xsLandingSounds: string[] = [];
    private static _fsDynamiteStoneSounds: string[] = [];
    private static _fsDynamiteChestSounds: string[] = [];
    private static _fsEmptyLandSounds: string[] = [];
    private static _dwarfAnticipationSoundPlayed: number[] = [];
    private static _dynamiteStoneCounter: number = 0;
    private static _dynamiteChestCounter: number = 0;
    private static _fsEmptyLandCounter: number = 0;
    private static _upgradeSymbolLandPlayed: boolean = false;
    private static _isFSReelLandingPlayed: boolean = false;
    private static _reelMultiplierTriggerPlayed: boolean = false;
    private static _scatterAnticipationPlayed: boolean;
    private static _scatterAnticipationLandingPlayed: boolean;
    private static _scatterAnticipationLandSounds: string[] = [];
    private static davidPanningReelStop: number[] = [-0.35, -0.25, -0.18, 0.01, 0.18, 0.25];

    private static get soundPlayer(): NolimitAudioPlayer {
        if (!this._init && NolimitConfig.isDevMode) {
            (<NolimitAudioPlayer>SlotGame.sound).showLogs(true);
            this._init = true;
        }
        return <NolimitAudioPlayer>SlotGame.sound;
    }

    public static fadeMusic(from: number, to: number, duration: number): void {
        // debugger;
        this.soundPlayer.fadeTrack({
            name: this.currentLoop,
            from: from,
            to: to,
            duration: duration
        });
    }

    public static fadeSoundEffect(name: string, from: number, to: number, duration: number): void {
        // debugger;
        this.soundPlayer.fadeTrack({
            name: name,
            from: from,
            to: to,
            duration: duration
        });
    }

    public static stopSoundEffect(name: string): void {
        this.soundPlayer.stopTrack(name);
    }

    public static playSound(name: string, repeat: number = 0): void {
        this.soundPlayer.playTrack({name: name, repeat: repeat});
    }

    public static stopAmbientLoop(dur: number = 200): void {
        if (this.currentLoop) {
            if (this.currentLoop.indexOf("fs") > -1) {
                this.stopSoundEffect(this.currentLoop);
            } else {
                const ambientLoop: NolimitHowl | undefined = this.soundPlayer.fadeTrack({
                    name: this.currentLoop,
                    from: 1,
                    to: 0,
                    duration: dur
                });
                ambientLoop && TweenLite.to(this, {duration: (dur / 1000)}).eventCallback("onComplete", () => {
                    this.stopSoundEffect(ambientLoop.soundName);
                });
            }
            this.currentLoop = "";
        }
    }

    public static playReelOut(): void {
        FITH2SoundManager.playSound(FITH2SoundConfig.REELS_OUT);
    }

    public static playReelIn(): void {
        this._reelLandingSoundId = [];
        FITH2SoundManager.playSound(FITH2SoundConfig.REELS_IN);
    }

    public static playAnticipationSound(): void {
        if (this._scatterAnticipationPlayed) {
            return;
        }
        this._scatterAnticipationPlayed = true;
        FITH2SoundManager.playSound("scatterAnticipation");
        this.soundPlayer.fadeTrack({
            name: this.currentLoop,
            from: 1,
            to: 0.7,
            duration: 100
        });
    }
    public static stopAnticipationSound(): void {
        FITH2SoundManager.stopSoundEffect("scatterAnticipation");
        this.soundPlayer.fadeTrack({
            name: this.currentLoop,
            from: 0.7,
            to: 1,
            duration: 300
        });
    }
    public static playAnticipationLandingSound(id: number): void {
        if (this.isQuickStop && this._scatterAnticipationLandingPlayed) {
            return;
        }
        this._scatterAnticipationLandingPlayed = true;
        FITH2SoundManager.playSound(this._scatterAnticipationLandSounds[id]);
    }

    public static playLandingSound(reelId: number): void {
        const sound: NolimitHowl | undefined = this.soundPlayer.playTrack({
            name: this._reelLandingSounds[reelId],
            repeat: 0
        });
        if (sound) {
            sound.player.stereo(FITH2SoundManager.davidPanningReelStop[reelId]);
        }
    }

    public static playCountUpStart(): void {
        FITH2SoundManager.playSound("winCountup");
    }

    private static getAmbientSoundName(): string {
        let musicName: string;
        if (FireInTheHole2.model.isRestore) {
            musicName = FireInTheHole2.model.isNormal ? FITH2SoundConfig.MAIN_GAME_AMBIANCE : FITH2SoundConfig.FS_INTRO;
        } else {
            //fs1 or fs2
            const fsName: string = `fs${FireInTheHole2.model.data.scatterCount === 3?"1":"2"}`;
            musicName = FireInTheHole2.model.isNextNormal ? FITH2SoundConfig.MAIN_GAME_AMBIANCE : fsName;
        }

        return musicName;
    }

    public static playAmbientLoop(duration: number = 200, name: string = "", volume: number = 1): void {
        name = name.length > 0 ? name : this.getAmbientSoundName();
        if (this.currentLoop === name) {
            return;
        }

        if (this.currentLoop) {
            this.stopAmbientLoop();
            this.playAmbientLoop(duration, name, volume);
        } else {
            this.currentLoop = name;
            this.soundPlayer.playTrack({name: this.currentLoop, volume: 0});
            this.soundPlayer.fadeTrack({
                name: this.currentLoop,
                from: 0,
                to: volume,
                duration: duration
            });
        }
    }

    public static playBigWinLevelSound(level: number): void {
        if (level === this._currentBigWinLevel) {
            return;
        }
        this._currentBigWinLevel = level;
        if (level === 0) {
            this._bigWinEndSoundPlayed = ArrayHelper.initArrayWithValues(5, () => false);
            FITH2SoundManager.fadeMusic(1, 0, 1200);
        }
        FITH2SoundManager.playSound(FITH2SoundConfig.BIGWIN[level], 0);
    }

    public static playFSIntroSound(): void {
        FITH2SoundManager.playSound("fsIntro");
        FITH2SoundManager.playAmbientLoop(1000, FITH2SoundConfig.FS_INTRO);
    }

    public static playWinCapMusic(): void {
        FITH2SoundManager.playSound(FITH2SoundConfig.WIN_CAP_MUSIC, 1000);
    }

    public static playBigWinEndSound(level: number): void {
        if (this._bigWinEndSoundPlayed[level]) {
            return;
        }
        FITH2SoundManager.fadeMusic(0, 1, 1200);
        this._bigWinEndSoundPlayed[level] = true;
        this.stopSoundEffect(FITH2SoundConfig.BIGWIN[level]);
        FITH2SoundManager.playSound(FITH2SoundConfig.BIGWIN_ENDS[level]);
        this._currentBigWinLevel = -1;
    }

    public static set newAvalanche(value: boolean) {
        this._newAvalanche = value;
        this._xsLandingSoundPlayed = !value;
        this._wildLandingPlayed = !value;
        this._scatterAnticipationPlayed = !value;
        this._scatterAnticipationLandingPlayed = !value;
        this._scatterLandingPlayed = !value;
        this._scatterFlashSoundPlayed = !value;
        this._scatterLandExtraPlayed = !value;
        this._wildCounter = 0;
        this._xsCounter = 0;
        this._reelLandingSounds = ArrayHelper.shuffle(FITH2SoundConfig.REEL_LANDING);

        const sounds_anticipation: string[] = ArrayHelper.shuffle(FITH2SoundConfig.SCATTER_LANDING);
        this._wildLandingSounds = ArrayHelper.shuffle(FITH2SoundConfig.WILD_LANDING);
        this._xsLandingSounds = ArrayHelper.shuffle(FITH2SoundConfig.XS_LANDING);
        this._scatterAnticipationLandSounds = sounds_anticipation.concat(sounds_anticipation);
    }

    public static get isQuickStop(): boolean {
        return FireInTheHole2.apiPlugin.settings.get(APISetting.FAST_SPIN);
    }

    public static playWildLandingSound(): void {
        if (this.isQuickStop && this._wildLandingPlayed) {
            return;
        }
        this._wildCounter++;
        this._wildLandingPlayed = true;
        FITH2SoundManager.playSound(this._wildLandingSounds[this._wildCounter%4]);
    }

    public static playScatterLandExtraSound(): void {
        const playOnce:boolean = (FireInTheHole2.model.data.wasFeatureBuy || this.isQuickStop);
        if (playOnce && this._scatterLandExtraPlayed) {
            return;
        }
        this._scatterLandExtraPlayed = true;
        FITH2SoundManager.playSound("scatterLandExtra");
    }

    public static playXSLandingSound(): void {
        if (this.isQuickStop && this._xsLandingSoundPlayed) {
            return;
        }
        this._xsCounter++;
        this._xsLandingSoundPlayed = true;
        FITH2SoundManager.playSound(this._xsLandingSounds[this._xsCounter%3]);
    }

    public static set newFSSpin(value: boolean) {
        this._dynamiteStoneCounter = 0;
        this._fsEmptyLandCounter = 0;
        this._dynamiteChestCounter = 0;
        this._upgradeSymbolLandPlayed = false;
        this._isFSReelLandingPlayed = false;
        this._reelMultiplierTriggerPlayed = false;
        this._dwarfAnticipationSoundPlayed = ArrayHelper.initArrayWithValues(6, ()=>0);
        this._fsDynamiteStoneSounds = ArrayHelper.shuffle(["fsDynamiteStone1", "fsDynamiteStone2", "fsDynamiteStone3"]);
        this._fsEmptyLandSounds = ArrayHelper.shuffle(["fsEmptyLand01", "fsEmptyLand02", "fsEmptyLand03"]);
        this._fsDynamiteChestSounds = ["fsDynamiteChest1", "fsDynamiteChest2"];
    }

    public static playDynamiteStoneSound(): void {
        this._dynamiteStoneCounter++;
        FITH2SoundManager.playSound(this._fsDynamiteStoneSounds[this._dynamiteStoneCounter%3]);
    }

    public static playDynamiteChestSound(): void {
        this._dynamiteChestCounter++;
        FITH2SoundManager.playSound(this._fsDynamiteChestSounds[this._dynamiteChestCounter%2]);
    }

    public static playFSMissSound(): void {
        this._fsEmptyLandCounter++;
        FITH2SoundManager.playSound(this._fsEmptyLandSounds[this._fsEmptyLandCounter%3]);
    }

    public static playUpgradeSymbolLandingSound(): void {
        if(this._upgradeSymbolLandPlayed){
            return;
        }
        this._upgradeSymbolLandPlayed = true;
        FITH2SoundManager.playSound("fsUpgradeLand");
    }

    public static playReelMultiplierTriggerSound(): void {
        if(this.isQuickStop && this._reelMultiplierTriggerPlayed){
            return;
        }
        this._reelMultiplierTriggerPlayed = true;
        FITH2SoundManager.playSound("fsMultiDownToCoin");
    }

    public static playDwarfAnticipationSound(reelId:number): void {
        if(FITH2Helper.sum(this._dwarfAnticipationSoundPlayed) > 0){
            this._dwarfAnticipationSoundPlayed[reelId] = 1;
            return;
        }
        this._dwarfAnticipationSoundPlayed[reelId] = 1;
        FITH2SoundManager.playSound("fsDwarfAnticipation");
    }

    public static stopDwarfAnticipationSound(reelId:number): void {
        const isPlaying:boolean = FITH2Helper.sum(this._dwarfAnticipationSoundPlayed)>0;
        this._dwarfAnticipationSoundPlayed[reelId] = 0;
        if(isPlaying && FITH2Helper.sum(this._dwarfAnticipationSoundPlayed) === 0){
            FITH2SoundManager.stopSoundEffect("fsDwarfAnticipation");
        }
    }

    public static playFSReelLandingSound(): void {
        if(this._isFSReelLandingPlayed){
            return;
        }
        this._isFSReelLandingPlayed = true;

    }

    public static playHighValueFSSymbolEnter(symName:string): void {
        if(symName === "DC"){
            FITH2SoundManager.playSound("fsDwarfEnters");
        }else if(symName === "R25"){
            FITH2SoundManager.playSound("fs25MultiEnters");
        }else if(symName === "C100"){
            FITH2SoundManager.playSound("fs100xEnters");
        }
    }
}